var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: 48,
  viewBox: "0 96 960 960",
  width: 48
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M180 976q-24 0-42-18t-18-42V296q0-24 18-42t42-18h65v-60h65v60h340v-60h65v60h65q24 0 42 18t18 42v620q0 24-18 42t-42 18H180Zm0-60h600V486H180v430Zm0-490h600V296H180v130Zm0 0V296v130Zm100 210v-60h400v60H280Zm0 180v-60h279v60H280Z"
})));
export default __webpack_public_path__ + "static/media/rate-card-icon.7255dca3.svg";
export { SvgComponent as ReactComponent };